import { ReactElement, memo } from 'react';
import Tooltip from '@mui/material/Tooltip';

import { useOrderOnAgendaStateInfo } from '~hooks/index';

import { OrderOnAgendaStateChipProps } from './types';
import { OrderOnAgendaStateChipRoot } from './styles';

const OrderOnAgendaStateChip = ({
  stateId,
  size = 'medium',
}: OrderOnAgendaStateChipProps): ReactElement => {
  const { description, color, tooltipMessage } =
    useOrderOnAgendaStateInfo(stateId);

  return (
    <Tooltip title={tooltipMessage} arrow>
      <OrderOnAgendaStateChipRoot
        variant="filled"
        label={description}
        color={color}
        size={size}
      />
    </Tooltip>
  );
};

export default memo(OrderOnAgendaStateChip);
